import React from 'react';
import { WHATSAPP_ICON } from '../../data/homeData';

export default function HomeFooter() {
  return (
    <footer className="home-footer">
      <div className="hf-top">
        <div className="hf-brand">
          <div className="logo-top">REDDY ANNA BOOK</div>
          <p>
            Reddy Anna Book is India&apos;s trusted online betting exchange — live cricket,
            football, tennis and 89+ casino games with instant deposits &amp; 24/7 support.
          </p>
        </div>
        <div className="hf-col">
          <h4>Sports</h4>
          <a href="/cricket">Cricket</a>
          <a href="/soccer">Football</a>
          <a href="/tennis">Tennis</a>
          <a href="/casino">Casino</a>
        </div>
        <div className="hf-col">
          <h4>Account</h4>
          <a href="/login">Login</a>
          <a href="/register">Sign Up</a>
          <a href="/deposit">Deposit</a>
          <a href="/withdraw">Withdraw</a>
        </div>
        <div className="hf-col">
          <h4>Help</h4>
          <a href="/rules">Rules</a>
          <a href="/referral">Referral</a>
          <a href="/reports/account-statement">Statement</a>
          <a href="/notifications">Notifications</a>
        </div>
      </div>
      <div className="hf-bottom">© {new Date().getFullYear()} Reddy Anna Book. All Rights Reserved.</div>
      <a className="hf-wa" href="/" title="WhatsApp" onClick={(e) => e.preventDefault()}>
        <img src={WHATSAPP_ICON} alt="WhatsApp" />
      </a>
    </footer>
  );
}
